var hero = hero || {};
var lazyLoader = require("luminoslabs/_lazy-loading");

if (!Object.create) {
    Object.create = (function () {
        function F() {}

        return function (o) {
            if (arguments.length != 1) {
                throw new Error('Object.create implementation only accepts one parameter.');
            }
            F.prototype = o;
            return new F()
        }
    })()
}

jQuery(function ( $ ) {

    $.fn.heroSlider = function( options ) {
        return this.each(function() {
            var heroSlider = Object.create(hero.heroSlider);
            heroSlider.init(this, options);
        });
    };

    $.fn.heroSlider.options = {
     };

    hero.heroSlider = {


        init (elem, options) {
            var self = this;
            self.$container = $(elem);
            // Slide Elements
            self.$slider = self.$container.find(".hero-slider");
            self.$single = self.$container.find(".hero-slide");
            self.$image = self.$container.find(".hero-slide__image");
            self.$currentSlide;

            // Footer Elements
            self.$triggers = self.$container.find(".hero-footer__trigger");
            self.$caption = self.$container.find(".hero-footer__caption")
            self.$current = self.$container.find(".hero-footer__current");
            self.$total = self.$container.find(".hero-footer__total");


            // Timer Elements
            self.$timer = self.$container.find(".hero-footer__timer");
            self.$speed = self.$container.data("time");
            self.bindElements();

        },

        bindElements () {
            var self = this;

            self.$slider.on("init", function(event, slick) {
                if( slick.slideCount > 1 ) {
                    self.$current.text( slick.currentSlide + 1);
                    self.$total.text( slick.slideCount );
                    self.timerToggle()
                } else {
                    self.singleSlide()
                }


                self.$currentSlide = slick.$slides[ slick.currentSlide ];

                self.clearCaption()
                self.setCaption();
            });

            self.$slider.on("beforeChange", function(event, slick, currentSlide) {
                self.clearTimer()
            });

            self.$slider.on("afterChange", function(event, slick, currentSlide) {
                self.$current.text( slick.currentSlide + 1 );
                self.timerToggle()

                self.clearCaption()

                self.$currentSlide = slick.$slides[ slick.currentSlide ];
                self.setCaption();
                lazyLoader.revalidate();

            });

            const options = $.extend({
                slidesToShow: 1,
                slidesToScroll: 1,
                lazyLoad: 'progressive',
                autoplay: false,
                autoplaySpeed: self.$speed,
                nextArrow: "<button class='hero-slide__button hero-slide__button--next'><svg class='hero-slide__icon' viewBox='0 0 100 100'><use xlink:href='#right-angle'></use></svg></button>",
                prevArrow: "<button class='hero-slide__button hero-slide__button--prev'><svg class='hero-slide__icon' viewBox='0 0 100 100'><use xlink:href='#left-angle'></use></svg></button>"
            }, self.$slider.data('slick'));

            self.$slider.slick(options);

            self.$triggers.on("click", function() {
                $(this).data("slide") ? self.$slider.slick('slickPrev') : self.$slider.slick('slickNext');
            });
        },
        timerToggle() {
            var self = this;

            self.$timer.css({
                width: "0%"
            }).animate({
                width: "100%"
            }, {
                duration: self.$speed,
                queue: false,
                easing: "linear"
            });
        },
        clearTimer() {
            var self = this;

            self.$timer.stop().css({
                width: "0%"
            });
        },
        setCaption() {
            var self = this;
            var caption = $( self.$currentSlide ).find(".hero-slide__caption").html() ;
            self.$caption.html( caption )
        },
        clearCaption() {
            var self = this;
            self.$caption.empty()
        },
        singleSlide() {
            var self = this;
            self.$container.find(".hero-footer__ticker, .hero-footer__trigger, .hero-footer__timer ").remove()
        }
    }
});
